import { Component, Input, forwardRef } from '@angular/core';
import { KeyValuePair } from '../../../models/common/keyValuePair';
import { ShippingLineService } from '../../../services/shipping-line.service';
import { AlertService } from '../../../services/alert.service';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
	selector: 'ztsi-shipping-line-select',
	templateUrl: './ztsi-shipping-line-select.component.html',
	styleUrls: ['./ztsi-shipping-line-select.component.css'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ZtsiShippingLineSelectComponent),
			multi: true
		}
	]
})
export class ZtsiShippingLineSelectComponent implements ControlValueAccessor {
	shippingLines: KeyValuePair[] = [];
	
	@Input('value') _value: string;
	@Input() isDisabled: boolean = false;

	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.onChange(val);
		this.onTouched();
	}

	constructor(
		private _shippingLineService: ShippingLineService,
		private _alertService: AlertService
	) { }

	writeValue(value): void {
		if (value !== undefined) {
			this._value = value;
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	ngOnInit() {
		this._shippingLineService.getShippingLinesDropdownList().subscribe(response => {
			if (response.length != undefined) {
				this.shippingLines = response;
			}
			else {
				console.log('Unable to load shipping line selection.');
			}
		})
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-shipping-line-select/ztsi-shipping-line-select.component.ts